export const environment = {
  production: true,
  API_BASE_URL: 'https://rdv.gustaveroussy.fr/api',
  RECAPTCHA_KEY: '6Lfg3r0UAAAAAFipy052W7MEIRHCqV1uBy4Pny-s',
};
